import React from 'react';
import { Box, Typography, Chip, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import BusinessIcon from "@mui/icons-material/Business";
import HandshakeIcon from "@mui/icons-material/Handshake";

export interface SelectedDistributorPartnerProps {
  selectedDistributor?: any;
  selectedPartner?: any;
}

export const SelectedDistributorPartner: React.FC<SelectedDistributorPartnerProps> = ({
  selectedDistributor,
  selectedPartner,
}) => {
  if (!selectedDistributor && !selectedPartner) return null;

  return (
    <Grid size={12}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          flexWrap: "wrap",
          backgroundColor: "#1D292E",
          padding: "12px 20px",
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        {selectedDistributor && (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <BusinessIcon sx={{ color: "#17B2EB !important", fontSize: 20 }} />
              <Typography fontSize={13} color="#A5A8A9">
                Selected Distributor:
              </Typography>
              <Chip
                label={`${selectedDistributor?.name || ""} ${selectedDistributor?.lastName || ""}`.trim() || "Distributor"}
                size="small"
                sx={{
                  backgroundColor: "rgba(23, 178, 235, 0.1)",
                  color: "#17B2EB",
                  fontWeight: 500,
                  borderRadius: "6px",
                }}
              />
            </Box>
          </>
        )}
        {selectedDistributor && selectedPartner && (
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: "rgba(90, 95, 96, 0.5)", mx: 1 }}
          />
        )}
        {selectedPartner && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <HandshakeIcon sx={{ color: "#17B2EB !important", fontSize: 20 }} />
            <Typography fontSize={13} color="#A5A8A9">
              Selected Partner:
            </Typography>
            <Chip
              label={`${selectedPartner?.name || selectedPartner?.centralUser?.name || "Unknown"} ${selectedPartner?.lastName || selectedPartner?.centralUser?.lastName || ""}`}
              size="small"
              sx={{
                backgroundColor: "rgba(23, 178, 235, 0.1)",
                color: "#17B2EB",
                fontWeight: 500,
                borderRadius: "6px",
              }}
            />
          </Box>
        )}
      </Box>
    </Grid>
  );
};
